import React from 'react';
import { motion } from 'framer-motion';
import '../styles/header.scss'; 

import { FaLinkedin, FaGithub } from 'react-icons/fa';
import { SiWhatsapp, SiInstagram } from 'react-icons/si';

const headerData = {
  name: 'Maikelen Salles',
  title: "Developer • Web Designer • UI/UX",
  desciption:"Especialista em desenvolvimento de sistemas, aplicativos, sites, portais de noticias e lojas virtuais. Transformando ideias em experiências digitais memoráveis com código limpo e design moderno.",
  image: 'https://avatars.githubusercontent.com/u/68317244?v=4', // Sua foto do GitHub
}

const socialsData = {
  linkedIn: 'https://www.linkedin.com/in/maikelen-salles',
  github: 'https://github.com/maikelensalles',
  whatsapp: 'https://api.whatsapp.com/send?phone=5551980418444&text=Ol%C3%A1%20Maikelen',
  instagram: 'https://www.instagram.com/maikelensalles/',
}

export function Header() {

    return (
    <div id="header">
        <div className='landing'>
            <div className='landing--container'>
                
                {/* LADO ESQUERDO: ÍCONES SOCIAIS */}
                <div className='landing--container-left'>
                    <div className='lcl--content'>
                        {[
                            { link: socialsData.linkedIn, icon: FaLinkedin, color: '#0077b5' },
                            { link: socialsData.github, icon: FaGithub, color: '#333' },
                            { link: socialsData.whatsapp, icon: SiWhatsapp, color: '#25D366' },
                            { link: socialsData.instagram, icon: SiInstagram, color: '#E1306C' }
                        ].map((item, index) => (
                            item.link && (
                                <motion.a
                                    key={index}
                                    href={item.link}
                                    target='_blank'
                                    rel='noreferrer'
                                    whileHover={{ scale: 1.2, y: -5, color: item.color }} 
                                    whileTap={{ scale: 0.9 }}
                                    style={{ display: 'inline-block' }} // Garante que a animação funcione
                                >
                                    <item.icon
                                        className='landing--social'
                                    />
                                </motion.a>
                            )
                        ))}
                    </div>
                </div>

                {/* CORREÇÃO DA FOTO: Envolvendo em uma div animada para não sumir */}
                <motion.div
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8 }}
                    className="landing--img-container" // Classe auxiliar se precisar
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                    <img
                        src={headerData.image}
                        alt={headerData.name}
                        className='landing--img'
                        style={{ display: 'block' }} // Força a imagem a aparecer
                    />
                </motion.div>

                {/* LADO DIREITO: TEXTOS */}
                <div className='landing--container-right'>
                    <div className='lcl--container'>
                         {/* Ícones Direita */}
                         {[
                           { link: socialsData.linkedIn, icon: FaLinkedin },
                           { link: socialsData.github, icon: FaGithub },
                           { link: socialsData.whatsapp, icon: SiWhatsapp },
                           { link: socialsData.instagram, icon: SiInstagram }
                        ].map((item, index) => (
                            item.link && (
                                <motion.a
                                    key={index}
                                    href={item.link}
                                    target='_blank'
                                    rel='noreferrer'
                                    whileHover={{ scale: 1.2, rotate: 10 }}
                                    style={{ display: 'inline-block' }}
                                >
                                    <item.icon className='duol--social' />
                                </motion.a>
                            )
                        ))}
                    </div>

                    <motion.div 
                        className='lcr--content'
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h6>{headerData.title}</h6>
                        <motion.h1 whileHover={{ scale: 1.02, originX: 0 }}>
                            {headerData.name}
                        </motion.h1>
                        <p>{headerData.desciption}</p>                      
                    </motion.div>
                </div>
            </div>
        </div>
    </div>
    )
}